import { createSlice } from "@reduxjs/toolkit";
import { createEncryptedAsyncThunk } from "../../Utility/APIUtils";

const initialState = {
  benDeleteSuccess: false,
  error: "",
  loading: false,
  creditAmountSucess: false,
  creditAmountResponse: {
    error: false,
    message: "",
  },
  commonDeleteResponse: {
    status: false,
    message: "",
  },
};

export const ppiRequest = createEncryptedAsyncThunk(
  "beneficiary/ppiRequest",
  "account/PPIRequestURL",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      merchant_code: `${params.customerMobileNumber}`,
      refid: "",
      redirect_url: "http://localhost:3000/PIPDMT/PipDMTSearchCustomer",
      serviceId: Number(params.serviceId.serviceId),
    }),
  }
);

export const merchantOnboarding = createEncryptedAsyncThunk(
  "beneficiary/merchantOnboarding",
  "account/PPIMerchantOnboarding",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      merchant_code: `${params.customerMobileNumber}`,
      name: params.fName,
      mobile: `${params.customerMobileNumber}`,
      email: params.currentUser.email,
      pan_number: params.panNumber,
      firmname: params.fName,
      address: params.address,
      pincode: params.pincode,
      state: params.selectState,
      serviceId: Number(params.serviceId.serviceId),
    }),
  }
);

export const addNewBeneficiary = createEncryptedAsyncThunk(
  "beneficiary/addNewBeneficiary",
  "transaction/RegisterBeneficiary",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      mobile: params.Mobile.customerMobileNumber,
      benename: params.beneBificiaryName,
      bankid: `${params.selectBank.value}`,
      accno: params.accountNumber,
      ifsccode: params.IfscCode,
      verified: "0",
      gst_state: `${params.loginData.state_ID}`,
      dob: "1992-04-05",
      address: "AT-123",
      pincode: "400706",
    }),
  }
);
export const addNewBeneficiarySelf = createEncryptedAsyncThunk(
  "beneficiary/addNewBeneficiarySelf",
  "account/CreateBenificiary",
  {
    prepareBody: (params) => ({
      remt_mobileno: params.Mobile.customerMobileNumber,
      cust_id: params.custId,
      userID: params.currentUser.userGuid,
      account_holder: params.beneBificiaryName,
      accountnumber: params.accountNumber,
      addresss: "At-123",
      ifsc: params.IfscCode,
      bank_id: Number(params.selectBank.value1),
      bank_name: params.selectBank.label,
      branch_address: "At-123",
      mobileno: params.Mobile.customerMobileNumber,
      reference_benificiary_id: `${params.res.bene_id}`,
    }),
  }
);

export const addCustomerEKYC = createEncryptedAsyncThunk(
  "beneficiary/addCustomerEKYC",
  "account/CustomerEKYC",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      customerMobileNo: params.KycMobileNumber,
      longitude: `${params.lng}`,
      latitude: `${params.lat}`,
      aadharNo: params.KycAdharNumber,
      otp: params.otp || "",
      otpref: params.otpref || "",
      panno: params.panno || "",
      referenceId: params.referenceId || "",
      ekyc_id: params.ekyc_id || "",
      biometric_data: params.captureData || "",
      serviceId: params.serviceId.serviceId,
      platform: "WEB",
      aadharImageData: params.aadharImageData || "",
      consentid: String(params.consentContent.consentId),
    }),
  }
);

export const Get_DIGIKHATA_ConsentLanguage = createEncryptedAsyncThunk(
  "AepsSlice/Get_DIGIKHATA_ConsentLanguage",
  "account/DIGIKHATA_ConsentLanguage",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      token: "",
      serviceId: params.serviceId.serviceId,
    }),
  }
);

export const Get_DIGIKHATA_Consent = createEncryptedAsyncThunk(
  "AepsSlice/Get_DIGIKHATA_Consent",
  "account/DIGIKHATA_Consent",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      consentlangId: params.selectLanguage.value,
      token: "",
      serviceId: params.serviceId.serviceId,
    }),
  }
);

export const walletTowallet = createEncryptedAsyncThunk(
  "AepsSlice/walletTowallet",
  "account/WalletBalanceTransfer",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      toMobileNo: params.MobileNumber,
      req_Amt: Number(params.amount),
      from_wallet_type: 1,
      to_wallet_type: 1,
      req_remark: "W2W",
      tpin: params.Tpin,
    }),
  }
);

export const addNewBeneficiarySelfIservue = createEncryptedAsyncThunk(
  "beneficiary/addNewBeneficiarySelfIservue",
  "transaction/RegisterBeneficiary",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      // userID: params.currentUser.userGuid,
      // remt_mobileno: params.Mobile.customerMobileNumber,
      // cust_id: params.custId,
      // account_holder: params.beneBificiaryName,
      // accountnumber: params.accountNumber,
      // addresss: "At-123",
      // ifsc: params.IfscCode,
      // bank_id: Number(params.selectBank.value1),
      // bank_name: params.selectBank.label,
      // branch_address: "At-123",
      // mobileno: params.Mobile.customerMobileNumber,
      // reference_benificiary_id: "",

      userId: params.currentUser.userGuid,
      benemobile: params.cutomerMobile,
      benename: params.beneBificiaryName,
      bankid: params.selectBank,
      accno: params.accountNumber,
      ifsccode: params.IfscCode,
      verified: "0",
      dob: "1990-12-20",
      address: "At-123",
      branch_address: "At-123",
      pincode: "413604",
      serviceid: params.serviceId.serviceId,
      txnType: "IMPS",
      customer_id: params.custId,
      beneficiaryVerified: params.verify,
    }),
  }
);
export const accountVerificationAdd = createEncryptedAsyncThunk(
  "beneficiary/accountVerificationAdd",
  "account/VerifyBeneficiaryByAccNo",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      serviceId: params.serviceId.serviceId,
      custId: params.custId,
      wallettype: 1,
      ifsc: params.IfscCode,
      accountNo: params.accountNumber,
      mobileNo: params.cutomerMobile,
      bankId: Number(params.selectBank),
    }),
  }
);

export const ValidateUserToken = createEncryptedAsyncThunk(
  "beneficiary/ValidateUserToken",
  "Token/ValidateUserToken",
  {
    transUrl: process.env.REACT_APP_API_TOKENSERVICE,
    prepareBody: (params) => ({
      token: params.Usertoken,
      userID: params.currentUser.userGuid,
    }),
  }
);
export const getServiceNotification = createEncryptedAsyncThunk(
  "beneficiary/getServiceNotification",
  "account/GetNotificationDetails",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      roles: params.roleId,
      serviceId: params.serviceId ? params.serviceId : [],
      city: [0],
      states: `${params.loginData.state_ID}`,
      languages: "",
      startDate: null,
      endDate: null,
    }),
  }
);
export const verifyBeneficiayForAdd = createEncryptedAsyncThunk(
  "beneficiary/verifyBeneficiayForAdd",
  "Modules/VerifyBankDetails",
  {
    prepareBody: (params) => ({
      ifsc: params.IfscCode,
      accountNumber: params.accountNumber,
      id: 0,
      beneficiary_Name: params.beneBificiaryName,
      iS_Verify: 0,
      userID: params.currentUser.userGuid,
    }),
  }
);
export const BeneficiaryDelete = createEncryptedAsyncThunk(
  "beneficiary/BeneficiaryDelete",
  "account/DeleteBeneficiary",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      serviceId: Number(params.serviceId.serviceId),
      // mobile: params.Mobile,
      bene_id: params.data.id,
    }),
  }
);
export const verifyBeneficiayDetails = createEncryptedAsyncThunk(
  "beneficiary/verifyBeneficiayDetails",
  "transaction/VerifyBeneficiaryTransaction",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      // userID: params.currentUser.userGuid,
      // serviceId: params.serviceId.serviceId,
      // wallettype: 1,
      // bene_id: Number(params.body.benificiary_Id),
      //agentid: "",
      //senderMobileNumber: params.Mobile.customerMobileNumber,
      //username: "",
      userID: params.currentUser.userGuid,
      serviceId: params.serviceId.serviceId,
      wallettype: 1,
      beneficiary_ID: Number(params.body.id),
      longitude: `${params.lng}`,
      latitude: `${params.lat}`,
    }),
  }
);
export const verifyBeneficiayDetailsForISRU = createEncryptedAsyncThunk(
  "beneficiary/verifyBeneficiayDetailsForISRU",
  "account/ISU_VerifyBeneficiaryTransaction",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      serviceId: params.currentService.serviceId,
      wallettype: 1,
      beneficiary_ID: params.body.benificiary_Id, //Number(params.body.benificiary_Id),
      tpin: "1234",
      username: "", // params.body.account_holder,
    }),
  }
);
export const setOTP = createEncryptedAsyncThunk(
  "beneficiary/setOTP",
  "Service/TwoWayAuthentication",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      type: "MOBILE_VERIFICATION",
      mode: {
        mode1: "SMS",
        mode2: "",
      },
      auth_mode: 0,
      receiverDetails: {
        mobileNo: params.Mobile.customerMobileNumber,
        emailId: "",
      },
      ipaddress: params.location.ip,
      substitutes: {
        additionalProp1: "",
        additionalProp2: "",
        additionalProp3: "",
      },
    }),
  }
);
export const verifyOtp = createEncryptedAsyncThunk(
  "beneficiary/verifyOtp",
  "Service/VerifyPreUserOTP",
  {
    prepareBody: (params) => ({
      otp: params.otp,
      auth_mode: 1,
      type: "MOBILE_VERIFICATION",
      mode: {
        mode1: "SMS",
        mode2: "",
      },
      receiverDetails: {
        mobileNo: params.Mobile.customerMobileNumber,
        emailId: "",
      },
    }),
  }
);
export const customerAdd = createEncryptedAsyncThunk(
  "beneficiary/customerAdd",
  "transaction/CreateCustomer",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => {
      let body = {
        userId: params.currentUser.userGuid,
        customerMobileNo: params.mobile,
        customerFirstName: params.fname,
        customerLastName: params.lname,
        serviceId: params.serviceId.serviceId,
        email: params.currentUser.email,
        ekyc_id: params.ekycId || "",
        otp_ref: params.otp_reference || "",
        aadharNo: params.aadhar || "",
        otp: params.otp || "",
        pincode: params.pincode || "",
        solicitek_DBStatus: params.Qryresponse.solicitekDBstatus || "",
        solicitek_VendorId: params.Qryresponse.solicitekVendorId || "",
        // internalVerification: {
        //   otpVerification: true,
        //   otp: params.otp || "",
        // },

        // dob: params.dob || null,
        // address: {
        //   country: "INDIA",
        //   city: params.city || "",
        //   state: params.selectState || "",
        //   pincode: params.pincode || "",
        //   district: params.selectDist || "",
        //   area: params.address || "",
        // },

        // verification: {
        //   otpVerification: params.otpVerification || false,
        //   otp: "",
        // },
        // ekoCreateCustomer: {
        //   otp_ref_id: "",
        //   otp: "",
        //   skipverification: "true",
        // },
      };
      return body;
    },
  }
);

export const verifyOTPCustomer = createEncryptedAsyncThunk(
  "beneficiary/verifyOTPCustomer",
  "transaction/CreateCustomer",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => {
      let body = {
        userId: params.currentUser.userGuid,
        customerMobileNo: params.mobile,
        customerFirstName: params.fname,
        customerLastName: params.lname,
        serviceId: params.serviceId.serviceId,
        email: params.currentUser.email,
        ekyc_id: params.ekycId || "",
        otp_ref: params.otp_reference || "",
        aadharNo: params.aadhar || "",
        otp: params.otp || "",

        // dob: params.dob || null,
        // address: {
        //   country: "INDIA",
        //   city: params.city || "",
        //   state: params.selectState || "",
        //   pincode: params.pincode || "",
        //   district: params.selectDist || "",
        //   area: params.address || "",
        // },

        // verification: {
        //   otpVerification: params.otpVerification || false,
        //   otp: "",
        // },
        // ekoCreateCustomer: {
        //   otp_ref_id: "",
        //   otp: "",
        //   skipverification: "true",
        // },
      };
      return body;
    },
  }
);

export const RegisterRemitter = createEncryptedAsyncThunk(
  "beneficiary/RegisterRemitter",
  "transaction/RegisterRemitter",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      mobile: params.Mobile.customerMobileNumber,
      firstname: params.fName,
      lastname: params.lName,
      address: params.address,
      otp: params.otp,
      pincode: params.pincode,
      stateresp: params.stateresp,
      bank3_flag: "No",
      dob: "1991-12-20",
      gst_state: `${params.selectState.value}`,
    }),
  }
);
export const getCustomerDetails = createEncryptedAsyncThunk(
  "beneficiary/getCustomerDetails",
  "account/GetCustomerList",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      cust_mobileNo: params.customerMobileNumber.customerMobileNumber,
      api_id: params.serviceId.api_id,
    }),
  }
);

export const getCustomerDetailsByMobileNumber = createEncryptedAsyncThunk(
  "beneficiary/getCustomerDetailsByMobileNumber",
  "Service/GetUserDetailsByMobNo",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      mobNo: params.MobileNumber,
      role: Number(params.selectRole),
    }),
  }
);

export const getRecentTransactionByUser = createEncryptedAsyncThunk(
  "beneficiary/getRecentTransactionByUser",
  "account/RecentTransactionByUser",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      recordLimit: params.recordLimit || 0,
      api_id: params.apiId || 0,
      accountnumber: params.accountnumber || "",
    }),
  }
);

export const getQuerryRemitter = createEncryptedAsyncThunk(
  "beneficiary/getQuerryRemitter",
  "transaction/QuerryRemitter",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      // userID: params.currentUser.userGuid,
      // serviceId: Number(params.serviceId.serviceId),
      // mobile: params.SearchNumber,
      // bank3_flag: "No",
      // txnType: "IMPS",
      userID: params.currentUser.userGuid,
      serviceId: Number(params.serviceId.serviceId),
      mobile: params.SearchNumber,
      latitude: `${params.lat}`,
      longitude: `${params.lng}`,
      updateLimit: true,
      otpToken: params.otpToken || "",
      otp: params.otp || "",
    }),
  }
);
export const getBeneficiaryList = createEncryptedAsyncThunk(
  "beneficiary/getBeneficiaryList",
  "transaction/FetchBeneficiary",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      // userID: params.currentUser.userGuid,
      // cust_id: params.customerData.cust_id,
      userId: params.currentUser.userGuid,
      mobile: params.SearchNumber,
      serviceId: Number(params.serviceId.serviceId),
      custid: Number(params.cust_id),
      txn_type: "IMPS",
    }),
  }
);

export const createCustomerPC = createEncryptedAsyncThunk(
  "beneficiary/createCustomerPC",
  "transaction/CreateCustomer",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => {
      let body = {
        userId: params.currentUser.userGuid,
        customerMobileNo: params.tenantMobileNO,
        customerFirstName: params.name,
        customerLastName: "",
        serviceId: params.serviceId.serviceId,
        email: params.currentUser.email,
        ekyc_id: params.ekycId || "",
        otp_ref: params.otp_reference || "",
        aadharNo: params.poiNumber || "",
        otp: params.otp || "",
        dob: params.dob || "",
        internalVerification: {
          otpVerification: true,
          otp: params.otp || "",
        },
      };
      return body;
    },
  }
);

export const benificiary = createSlice({
  name: "beneficiary",
  initialState,
  reducers: {
    creditAmountSuccess(state) {
      return { ...state, creditAmountSucess: true };
    },
    creditAmountFailed(state, action) {
      return {
        ...state,
        creditAmountResponse: { error: true, message: action.payload },
      };
    },
    FetchSuccess(state, action) {
      return { ...state, recharge: action.payload.Data[0] };
    },
    FetchFailed(state, action) {
      return {
        ...state,
        rechargeResponse: { status: true, message: action.payload },
      };
    },
    DeleteSuccess(state) {
      return { ...state, loading: false, benDeleteSuccess: true };
    },
    DeleteFailed(state, action) {
      return {
        ...state,
        fetchError: false,
        benDeleteSuccess: false,
        commonDeleteResponse: { status: true, message: action.payload },
      };
    },
    DeleteInitial(state) {
      return {
        ...state,
        benDeleteSuccess: false,
        commonDeleteResponse: { status: false, message: "" },
      };
    },
  },
});
export const {
  FetchSuccess,
  FetchFailed,
  DeleteSuccess,
  DeleteFailed,
  DeleteInitial,
  creditAmountSuccess,
  creditAmountFailed,
} = benificiary.actions;
export default benificiary.reducer;
